<template>
  <div>
    <LvFlexBox
      v-for="(condition, conditionIndex) in list"
      :key="conditionIndex"
      :class="{'mb-8': conditionIndex !== list.length - 1}"
    >
      <LvText class="mr-4">{{ $t('當') }}</LvText>
      <LvText bold class="mr-4">{{ $t(`${condition.operator}`) }}</LvText>
      <LvText v-if="condition.lowVal !== undefined" bold class="mr-4">{{ condition.lowVal }}</LvText>
      <LvText
        v-if="condition.lowVal !== undefined && condition.highVal !== undefined && condition.highVal !== null"
        class="mr-4"
      >{{ $t('與') }}</LvText>
      <LvText v-if="condition.highVal !== undefined && condition.highVal !== null" bold class="mr-4">{{ condition.highVal }}</LvText>
      <LvText class="mr-4">{{ $t('符合') }}</LvText>
      <LvText bold>{{ $t(`${condition.risk}`) }}</LvText>
    </LvFlexBox>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    }
  }
}
</script>